import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CardGridComponent } from './card-grid.component';
import { DropDownListModule } from '@progress/kendo-angular-dropdowns';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { GridCardComponent } from './grid-card/grid-card.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    DropDownListModule
  ],
  declarations: [
    CardGridComponent,
    GridCardComponent
  ],
  exports: [
    CardGridComponent,
    GridCardComponent
  ]
})
export class CardGridModule { }
